import React, { useRef, useEffect, useCallback } from 'react';
import FormGroup from './FormGroup';
import './Textarea.css';

const Textarea = ({
  label,
  helpText,
  error,
  required,
  optional,
  rows = 1,
  className = '',
  value,
  onChange,
  ...props
}) => {
  const ref = useRef(null);

  const autoResize = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  }, []);

  useEffect(() => { autoResize(); }, [value, autoResize]);

  return (
    <FormGroup label={label} helpText={helpText} error={error} required={required} optional={optional}>
      <textarea
        ref={ref}
        className={`p-textarea p-textarea--auto ${className}`}
        rows={rows}
        required={required}
        value={value}
        onChange={onChange}
        {...props}
      />
    </FormGroup>
  );
};

export default Textarea;
